import React from 'react';
import {
  generateGradientDef,
  generateShapes,
  getRadiusForLayer,
} from '../../utils/svgUtils';
const LegendDisplay = ({ layerSettings, size = 80, spacing = 16, zoom = 1, radius=10 }) => {
  // You can adapt generateShapes and generateGradientDef as needed
  const center = size / 2;
 
  return (
    <div style={{ display: 'flex', gap: spacing, justifyContent: 'center' }} className='legend'>
      {layerSettings.map((layer, index) => {
        if (layer.showItem === false) return null;
         const n = layer.numShapes && layer.numShapes > 0 ? layer.numShapes : 1;
          const rotateDeg = -90;
          const applyTransform = n > 1;
          
        return (
          <div key={index} style={{ textAlign: 'center' }}>
            <svg
              width={size}
              height={size}
              viewBox={`0 0 ${size} ${size}`}
              xmlns="http://www.w3.org/2000/svg"
            >
              {/* <defs>
                {layer.colorData?.type !== 'solid' &&
                  generateGradientDef(index, layer.colorData, getRadiusForLayer, size, true)}
              </defs> */}
              <defs>
                  {
                  layer.colorData?.type !== 'solid'
                    ? generateGradientDef(index, layer.colorData, radius, size, true)
                    : null
                  }
              </defs>

              <g
                style={{ mixBlendMode: layer.blendMode }}
                stroke={
                  layer.colorData?.type === 'solid'
                    ? layer.colorData.color || layer.colorData.color1 || '#D531CE'
                    : `url(#gradient-${index}0)`
                }
                opacity={layer.opacity}
                strokeWidth={layer.numShapes > 99 ? 0.01 : 0.1}
                 transform={applyTransform ? `rotate(${rotateDeg} ${center} ${center})` : undefined}
              >
                {generateShapes(layer, index, size, true)}
              </g>
            </svg>
            <div className='legend-text'>
              {layer.name} - {layer.numShapes}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default LegendDisplay;
